import React from "react";
import { connect } from "react-redux";

import { Link, Redirect } from "react-router-dom";
import "./signin.css";
import { addUser } from "store/actions/security";
import API from "api";
import Axios from "axios";

class ConfirmRegistration extends React.Component {
  state = {
    processing: true,
    error: null,
    success: null,
    user: null
  };

  componentDidMount() {
    API.confirmRegistration(this.props.match.params.token)
      .then(response => {
        const data = response.data;

        API.profile(data.api_key || data.apiKey).then(res => {
          const user = res.data;

          // login user;
          const expiresAt = new Date();
          user.last_login = new Date();
          expiresAt.setDate(expiresAt.getDate() + 7);
          Axios.defaults.headers.common["Authorization"] = user.api_key;
          user.accessUntil = expiresAt;

          this.setState(
            {
              error: null,
              submitting: false
            },
            () => {
              this.props.addUser(user);
            }
          );
        });
      })
      .catch(error => {
        // console.warn("error", error);
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log(error.response.data);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          this.setState({
            processing: false,
            error: error.response.data.message
          });
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          //console.log(error);
          this.setState({
            processing: false,
            error: error.message || "Error lors de l'activation de votre compte"
          });
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
          this.setState({ processing: false, error: error.message });
        }
      });
  }
  render() {
    const { error, message } = this.state;
    if (this.props.isAuth) {
      return (
        <Redirect
          to={{
            pathname: "/publications",
            state: { from: this.props.location }
          }}
        />
      );
    }

    return (
      <div className=" min-vh-100 d-flex  justify-content-center align-items-center">
        {error && (
          <div className="text-center">
            <p className="text-danger text-center">{error}</p>
            <Link color="inherit" underline="none" to="/publications">
              Accéder aux titres
            </Link>
          </div>
        )}
        {message && <p className="text-success text-center">{message}</p>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuth: Boolean(state.security.user)
});
const mapActionsToProps = dispatch => ({
  addUser: user => dispatch(addUser(user))
});
export default connect(mapStateToProps, mapActionsToProps)(ConfirmRegistration);
